import { useState } from 'react'
import { auth, db } from "../firebase/FirebaseConfig"
import { useAuthContext } from './useAuthContext'
import { signOut } from 'firebase/auth';
import { collection, doc, updateDoc } from 'firebase/firestore';

export const useLogout = () => {
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const { dispatch, user } = useAuthContext()
  
  const logout = async () => {
    setError(null)
    setIsPending(true)

    try {
      if (!user) {
        throw new Error('No user cuurently logged in')
      }
    //   const { uid } = user
    //   const collRef = collection(db, 'users')
    //   const userDocRef = doc(collRef, uid)
    //   await updateDoc(userDocRef, { online: false })


      // sign the user out
      await signOut(auth)
      
      // dispatch logout action
      dispatch({ type: 'LOGOUT' })
      setIsPending(false)
      setError(null)
    } 
    catch(err) {
      setError(err.message)
      setIsPending(false)
      console.log(err.message)
    }
  }


  return { logout, error, isPending }
}